










import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';

const ui = namespace('UI');

@Component({
  components: {
    Popup,
  },
})
export default class PausePopup extends Vue {
  @ui.Mutation
  private closePopup!: () => void;

  private continueStr: string = (window as any).languages['Continue'];
  private gamePaused: string = (window as any).languages['GamePaused'];
}
